// @flow
import React, { PureComponent } from 'react';
import ChartComponent from 'react-chartjs-2';
import Console from '../../../lib/debug';

type Props = {
    dataColumns: array,
    graphProps: object
};

export default class ChartJs extends PureComponent<Props> {
    render() {
        Console.render('Chart');
        const [xValues, yValues] = this.props.dataColumns;
        return (
            <ChartComponent
                id={this.props.graphProps.bindToElement}
                type={this.props.graphProps.chartType}
                options={this.props.graphProps.options}
                data={{
                    labels: xValues,
                    datasets: yValues
                }}
            />
        );
    }
}
